import * as React from "react";

import { getRoutePath, redirectToRoutePath, sectionClasses } from "../common/Utils";
import { QuoteFormEventType } from "../../../Common/QuoteFormEventTracking/QuoteFormEventType";
import { WizardStep } from "../common/WizardStep";

import { IStepProps } from "../interfaces/IStepProps";
import { IStepState } from "../interfaces/IStepState";
import { IAutoWizardModel } from "../interfaces/IAutoWizardModel";

import { LogStep } from "../../../Common/QuoteFormEventTracking/LogStep";

interface IIncidentsStepState extends IStepState {
    atFaultAccidents?: boolean;
    tickets?: boolean;
    duis?: boolean;
    filingRequired?: boolean;
}

export class IncidentsStep extends React.Component<IStepProps, IIncidentsStepState> {
    state: IIncidentsStepState;

    constructor(props: IStepProps) {
        super(props);

        this.handleOnClickTouchOption = this.handleOnClickTouchOption.bind(this);
        this.handleOnClickContinueButton = this.handleOnClickContinueButton.bind(this);

        this.state = {
            atFaultAccidents: this.props.model.atFaultAccidentInThePastThreeYears === "True",
            tickets: this.props.model.twoOrMoreTicketsInThePastThreeYears === "True",
            duis: this.props.model.duiConvictionInThePastThreeYears === "True",
            filingRequired: this.props.model.duiConvictionInThePastThreeYears === "True",
            redirectPath: "",
            goToNextStep: false
        }
    }

    handleOnClickTouchOption(event: React.MouseEvent<HTMLSpanElement>): void {
        let valueElement = event.target as HTMLSpanElement;
        let value = valueElement.dataset["value"];
        let name = valueElement.dataset["name"];

        if (name === "atFaultAccidents") {
            this.setState({ atFaultAccidents: value === "True" });
        }

        if (name === "tickets") {
            this.setState({ tickets: value === "True" });
        }

        if (name === "duis") {
            this.setState({ duis: value === "True" });
            this.setState({ filingRequired: value === "True" });
        }
    }

    handleOnClickContinueButton(event: React.MouseEvent<HTMLAnchorElement>): void {
        let model: IAutoWizardModel = JSON.parse(JSON.stringify(this.props.model));

        model.atFaultAccidentInThePastThreeYears = this.state.atFaultAccidents ? "True":"False";
        model.twoOrMoreTicketsInThePastThreeYears = this.state.tickets ? "True":"False";
        model.duiConvictionInThePastThreeYears = this.state.duis ? "True" : "False";
        model.primaryDriver.filingRequired = this.state.duis ? "True" : "False";

        this.props.onUpdateModel(model);

        const routePath = getRoutePath(WizardStep.MARITAL_STATUS);

        this.setState({ redirectPath: routePath, goToNextStep: true });
    }

    getAccidentsSelectedClass(optionValue: string): string {
        const atFaultAccidentsValue: string = this.state.atFaultAccidents ? "True" : "False";

        if (optionValue === atFaultAccidentsValue) {
            return "selected";
        }

        return "";
    }

    getTicketsSelectedClass(optionValue: string): string {
        const ticketsValue: string = this.state.tickets ? "True" : "False";

        if (optionValue === ticketsValue) {
            return "selected";
        }

        return "";
    }

    getDuisSelectedClass(optionValue: string): string {
        const duisValue: string = this.state.duis ? "True" : "False";

        if (optionValue === duisValue) {
            return "selected";
        }

        return "";
    }

    render(): JSX.Element {
        if (this.state.goToNextStep) {
            redirectToRoutePath(this.state.redirectPath);
            return null;
        }

        const sectionStyle = {
            display: 'block'
        }

        const paragraphClasses: string = "text-center";

        const paragraphStyle = {
            marginTop: 15 
        }

        return <React.Fragment>
            <LogStep lastStep="LicenseStatus" nextStep="MaritalStatus" stepNumber={QuoteFormEventType.IncidentsStepLoad} sectionName="Incidents" wizardName="AutoWizard" logStep={true}/>
            <div id="IncidentsStep" className={sectionClasses} style={sectionStyle}>
                   <h3>Has anyone on this policy had:</h3>
                   <div id="Incidents">
                    <div className="touch-list twoColumn">
                        <p className={paragraphClasses}>An at-fault accident in the past <strong>three (3) years</strong>?</p>
                        <div className="touch-list-option"><span className={this.getAccidentsSelectedClass("True")} id="accident_Yes" data-value="True" data-name="atFaultAccidents" onClick={this.handleOnClickTouchOption}>Yes</span></div>
                        <div className="touch-list-option"><span className={this.getAccidentsSelectedClass("False")} id="accident_No" data-value="False" data-name="atFaultAccidents" onClick={this.handleOnClickTouchOption}>No</span></div>
                        <p className={paragraphClasses} style={paragraphStyle}><strong>Two (2) or more</strong> tickets in the past <strong>three (3) years</strong>?</p>
                        <div className="touch-list-option"><span className={this.getTicketsSelectedClass("True")} id="tickets_Yes" data-value="True" data-name="tickets" onClick={this.handleOnClickTouchOption}>Yes</span></div>
                        <div className="touch-list-option"><span className={this.getTicketsSelectedClass("False")}  id="tickets_No" data-value="False" data-name="tickets" onClick={this.handleOnClickTouchOption}>No</span></div>
                        <p className={paragraphClasses} style={paragraphStyle}>A DUI conviction in the past <strong>three (3) years or need an SR-22 form</strong>?</p>
                        <div className="touch-list-option"><span className={this.getDuisSelectedClass("True")} id="dui_Yes" data-value="True" data-name="duis" onClick={this.handleOnClickTouchOption}>Yes</span></div>
                        <div className="touch-list-option"><span className={this.getDuisSelectedClass("False")} id="dui_No" data-value="False" data-name="duis" onClick={this.handleOnClickTouchOption}>No</span></div>
                       </div>
                        <a onClick={this.handleOnClickContinueButton} id="continueStepIncidents" className="continueButton">CONTINUE</a>
                   </div>
            </div>
        </React.Fragment>;
    }
}